import {Component, Input} from '@angular/core';
import {Product} from "@app/core/product/domain/dtos/product";
import {AddPdfCatalogProductUseCase} from "@app/core/pdf-catalog/application/add-pdf-catalog-product-use-case";
import {
    RemovePdfCatalogProductUseCase
} from "@app/core/pdf-catalog/application/remove-pdf-catalog-product-use-case.service";
import {GetPdfCatalogProductsUseCase} from "@app/core/pdf-catalog/application/get-pdf-catalog-products-use-case";

@Component({
    selector: 'app-add-remove-pdf-button',
    templateUrl: './add-remove-pdf-button.component.html',
})
export class AddRemovePdfButtonComponent {
    @Input() product?: Product;
    productExist: boolean | undefined;

    constructor(
        private removeProductToPdfCatalogUseCase: RemovePdfCatalogProductUseCase,
        private addOneProductsToPdfCatalogUseCase: AddPdfCatalogProductUseCase,
        private getPdfCatalogProductsUseCase: GetPdfCatalogProductsUseCase,
    ) {
    }

    ngOnInit() {
        this.getPdfCatalogProductsUseCase.execute()
            .subscribe({
                next: products => {
                if (this.product && this.product.code) {
                    this.productExist = products.some(p => p.code === this.product?.code);
                }
            }});
    }

    addProduct() {
        if (this.product?.code) {
            this.addOneProductsToPdfCatalogUseCase.execute(this.product);
        }
    }

    removeProduct() {
        if (this.product?.code) {
            this.removeProductToPdfCatalogUseCase.execute(this.product.code);
        }
    }

    onClickHandler() {
        if (this.productExist) {
            return this.removeProduct();
        } else {
            return this.addProduct();
        }
    }
}
